module.exports = __webpack_public_path__ + "img/united-states.49591c6d.svg";